module.exports = __webpack_public_path__ + "static/media/unificacao-icon.5af41ec2.svg";